import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import React, { useEffect, useState } from 'react';
import { Button, Input, Row, Col, Table } from 'reactstrap';

import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import firebase from 'firebase';
import { useNavigate } from 'react-router-dom';

const AddQuestionQuiz = ({ quizDetails, handleClose }) => {
  const [fetchSubject, setFetchSubject] = useState([]);
  const [currentSubject, setCurrentSubject] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [active, setactive] = useState(false);
  const [quizQuestionData, setquizQuestionData] = useState([]);
  const [quizDate, setquizDate] = useState([]);
  const [lastVisible, setLastVisible] = useState();
  const [hasNextPage, setHasNextPage] = useState(false);
  const [quizData, setQuizData] = useState({});
  const navigate = useNavigate()
  
  const getSubjectDetail = async (quizData) => {
    try {
      const getSubjectIds = quizData.subjectWeightage.map((sub) => sub.subjectId);

      if (!getSubjectIds.length) {
        console.log("No subject IDs found.");
        return;
      }

      console.log("Fetching subjects with IDs:", getSubjectIds);

      const chunkSize = 10; // Firestore limit for 'in' queries
      const subjectChunks = [];

      for (let i = 0; i < getSubjectIds.length; i += chunkSize) {
        subjectChunks.push(getSubjectIds.slice(i, i + chunkSize));
      }

      const subjectPromises = subjectChunks.map((chunk) =>
        db.collection("subjects")
          .where(firebase.firestore.FieldPath.documentId(), "in", chunk)
          .where("status", "==", 0)
          .get()
      );

      const results = await Promise.all(subjectPromises);

      const subjects = [];
      results.forEach((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          subjects.push({ id: doc.id, ...doc.data() });
        });
      });

      setFetchSubject(subjects);
      if (subjects.length > 0) setCurrentSubject(subjects[0].name);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };


  const setQuesDataWrapper = (data, searchQuery) => {
    // If data is a function, invoke it with quizQuestionData as an argument
    if (typeof data === 'function') data = data(quizQuestionData);

    // Extract and format the question data
    const extractQuestionV2 = data?.map((item) => {
      let question = item[item?.primaryLanguage];
      console.log(quizData?.quizQuestions?.includes(item?.id), 'isChecking1312');
      let [optionA, optionB, optionC, optionD] = question?.options;
      return {
        id: item?.id,
        isAlreadyAdded: quizData?.quizQuestions?.includes(item?.id),
        questionNumber: item?.questionNumber,
        questionLanguages: item?.questionLanguages,
        isSelected: item?.select,
        subject: item?.subject,
        topic: item?.topic,
        question: question?.question,
        correctOption: question?.correctOption,
        optionA,
        optionB,
        optionC,
        optionD,
      };
    });
    console.log(quizData.quizQuestions);
    console.log(extractQuestionV2, 'topicFilter');
    setquizQuestionData(extractQuestionV2);
  };

  const getQuestions = async (
    searchQuery
  ) => {
    console.log('Executed getQuestions with search query:', searchQuery);
    document.querySelector('#loading-indicator').style.display = 'flex';
    setLoading(true);

    const skipCount = (currentPage - 1) * limit;

    try {
      let baseQuery = db
        .collection('QuestionsV2')
        .where('subject', '==', currentSubject)
        .where('status', '==', 0)
        .limit(limit + 1); // Fetch one extra document to check if more exist

      if (currentPage > 1 && lastVisible) {
        baseQuery = baseQuery.startAfter(lastVisible);
      }

      let docs = [];

      if (searchQuery?.trim()) {
        let searchLower = searchQuery.trim();

        // Queries must order by `primaryQuestion` for range filters
        const query1 = baseQuery
          .orderBy('primaryQuestion')
          .where('primaryQuestion', '>=', searchLower)
          .where('primaryQuestion', '<=', searchLower + '\uf8ff');

        const query2 = baseQuery
          .orderBy('topic')
          .where('topic', '>=', searchLower)
          .where('topic', '<=', searchLower + '\uf8ff');

        const query3 = baseQuery.where(
          'questionLanguages',
          'array-contains',
          searchLower
        );

        // Execute all queries in parallel
        let querySnapshots = await Promise.all([
          query1.get(),
          query2.get(),
          query3.get(),
        ]);

        // Merge results without duplicates
        let docsMap = new Map();
        querySnapshots.forEach((snapshot) => {
          snapshot.docs.forEach((doc) => docsMap.set(doc.id, doc));
        });

        docs = Array.from(docsMap.values());
      } else {
        // When no search, order by `questionNumber`
        let querySnapshot = await baseQuery
          .orderBy('questionNumber', 'asc')
          .get();
        docs = querySnapshot.docs;
      }

      if (docs.length === 0) {
        console.warn('No more questions found.');
        document.querySelector('#loading-indicator').style.display = 'none';
        setLoading(false);
        setQuesDataWrapper([], searchQuery);
        setStartIndex(0);
        setEndIndex(0);
        setHasNextPage(false);
        return;
      }

      let hasNextPage = docs.length > limit;
      if (hasNextPage) {
        docs.pop(); // Remove extra document
      }

      let data = docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
        select: false,
      }));
      console.log(data, 'checking1212');
      setLastVisible(docs[docs.length - 1] || null);
      setHasNextPage(hasNextPage);
      document.querySelector('#loading-indicator').style.display = 'none';
      setLoading(false);
      console.log('Data fetched successfully.', { hasNextPage });

      setQuesDataWrapper(data, searchQuery);
      setStartIndex(skipCount + 1);
      setEndIndex(skipCount + data.length);
    } catch (err) {
      console.error('Error fetching questions:', err);
      document.querySelector('#loading-indicator').style.display = 'none';
      setLoading(false);
    }
  };

  const fetchQuizDetail =async()=>{
    try {
      const quizRef = db.collection("QuizTest");
      const snapshot = await quizRef.where("id", "==", quizDetails.quizId).get();

      if (snapshot.empty) {
        console.log("No matching quiz found.");
        return;
      }

      const quizData = snapshot?.docs[0]?.data();
      console.log('quizData1', quizData);
      setQuizData(quizData);
      getSubjectDetail(quizData);

    } catch (error) {
      console.log(error);
    }
  }

  const handleAddQuestion = async (question) => {
    try {
      // Show loading indicator
      document.querySelector('#loading-indicator').style.display = 'flex';

      if (!quizDetails?.quizId) {
        console.log("Mock ID is missing.");
        document.querySelector('#loading-indicator').style.display = 'none';
        return;
      }

      // const quizRef = db.collection("QuizTest");
      // const snapshot = await quizRef.where("id", "==", quizDetails.quizId).get();

      // if (snapshot.empty) {
      //   console.log("No matching quiz found.");
      //   return;
      // }

      if (!quizData?.quizQuestions) {
        console.log('inValid Opration ');
        document.querySelector('#loading-indicator').style.display = 'none';
        return
      } else if (quizData?.quizQuestions?.includes(question.id)) {
        console.log('Mock already Contain this Question ==>', question.id);
        document.querySelector('#loading-indicator').style.display = 'none';
        return
      } else if (quizData.numberOfQuation <= quizData?.quizQuestions?.length){
        console.log('Mock Can Contain Only ==>', quizData.numberOfQuation);
        document.querySelector('#loading-indicator').style.display = 'none';
        return
      }
      const dataArr = [...quizData.quizQuestions, question.id];
      console.log(question);
      console.log('Adding question with subject:', question.subject);

      const quizQuestionsUpdate = db.collection("QuizTest")
        .doc(quizDetails.quizId)
        .update({ quizQuestions: dataArr });

      const questionInsert = db.collection(`QuizTest/${quizData.id}/QuationCollection`)
        .add({
          subject: question.subject, // Use question.subject instead of currentSubject
          QuationsV2Id: question.id
        });

      // Run both operations in parallel
      await Promise.all([quizQuestionsUpdate, questionInsert]);
      quizData.quizQuestions = dataArr;
      setQuizData(quizData);
      
      // Hide loading indicator before refreshing questions
      document.querySelector('#loading-indicator').style.display = 'none';
      getQuestions()
    } catch (error) {
      console.error("Error fetching quiz details or adding question:", error);
      // Hide loading indicator on error
      document.querySelector('#loading-indicator').style.display = 'none';
    }
  };


  const fetchQuestionsForSubject = (subject, numQuestions) => {
    return new Promise((resolve, reject) => {
      const questions = [];

      // Fetch questions from the QuestionsV2 collection based on the subject
      const questionsRef = db
        .collection('QuestionsV2')
        .where('subject', '==', subject);
      questionsRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const question = doc.data();
            questions.push({
              id: doc.id, // The ID of the question from QuestionsV2
              subject: question.subject, // Subject of the question
              question: question.question, // The actual question
              correctOption: question.correctOption,
              options: question.options,
              difficulty: question.difficulty,
              primaryLanguage: question.primaryLanguage,
              questionLanguages: question.questionLanguages,
              questionNumber: question.questionNumber,
              status: question.status,
              topic: question.topic,
              createdAt: question.createdAt,
            });
          });

          // Resolve with the fetched questions
          resolve(questions);
        })
        .catch((error) => {
          reject('Error fetching questions from QuestionsV2:', error);
        });
    });
  };

  const handleSearch = (searchString) => {
    if (searchString==''){
      getQuestions()
    }else{
      getQuestions(searchQuery);
    }
  };

  useEffect(() => {
    fetchQuizDetail();
    // getSubjectDetail();
  }, []);

  useEffect(() => {
    getQuestions();
  }, [currentSubject, currentPage, limit]);

  return (
    <div
      style={{
        backgroundColor: '#1f1e2e',
        height: '100%',
        overflowY: 'scroll',
      }}
    >
      <Row style={{ justifyContent: 'space-between', padding: '24px' }}>
     <div></div>
        <div>
          <IconButton
            edge='start'
            style={{ color: 'white', marginLeft: 'auto', display: 'block' }}
            onClick={handleClose}
            aria-label='close'
          >
            <CloseIcon />
          </IconButton>
        </div>
      </Row>   
      <h5 style={{ margin: '0',marginLeft:'30px' }} className='title'>
          {quizDetails?.quizName}
        </h5>
      <Row style={{ padding: '24px ' }} className='align-items-center'>
        {/* Search Input and Button */}
        <Col sm={5} className='d-flex align-items-center'>
          <select
            id='subject'
            className='form-control'
            value={currentSubject}
            onChange={(e) => {
              setCurrentSubject(e.target.value);
              setCurrentPage(1);
            }}
            style={{
              maxWidth: '200px',
              height: '40px',
              border: '1px solid rgb(42.67, 52.71, 82.83)',
              borderRadius: '4px',
              padding: '5px 10px',
            }}
          >
            <option value=''>-- Select Subject --</option>
            {fetchSubject.map((subject) => (
              <option key={subject.id} value={subject.name}>
                {subject.name}
              </option>
            ))}
          </select>
          <Input
            type='text'
            name='search'
            placeholder='Search'
            onChange={(e) =>{
              setSearchQuery(e.target.value)
              if (e.target.value ==''){
                handleSearch(e.target.value);
              }
            }}
            style={{
              flex: 1,
              marginRight: '10px',
              height: '40px',
              borderRadius: '4px',
              marginLeft: '5px',
            }}
          />
          <Button
            color='info'
            onClick={() => handleSearch()}
            style={{
              height: '40px',
              padding: '0 15px',
            }}
          >
            <SearchIcon />
          </Button>
        </Col>
        
        {/* Pagination Controls */}
        <Col sm={7} className='d-flex justify-content-end align-items-center'>
          <p style={{ marginRight: '20px',marginTop:'7px' }}>Mock Question : {quizData?.quizQuestions?.length}/{quizData?.numberOfQuation}</p>
          {console.log(quizData,'pleaseCheckIt')}
          <p
            style={{
              marginRight: '15px',
              marginBottom: '0',
              whiteSpace: 'nowrap',
            }}
          >
            {currentPage * limit - (limit - 1)}-{currentPage * limit}
          </p>
          <IconButton style={{ outline: 'none' }}>
            {currentPage > 1 ? (
              <KeyboardArrowLeftSharpIcon
                style={{ color: '#fff' }}
                onClick={() => {
                  setCurrentPage(currentPage - 1);
                }}
              />
            ) : (
              ''
            )}
          </IconButton>
          {hasNextPage ? (
            <IconButton style={{ outline: 'none' }}>
              <KeyboardArrowRightSharpIcon
                style={{ color: '#fff' }}
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
              />
            </IconButton>
          ) : (
            ''
          )}
          <select
            className='form-control'
            onChange={(e) => {
              setLimit(parseInt(e.target.value));
            }}
            style={{
              maxWidth: '67px',
              height: '40px',
              color: '#fff', // White text
              borderRadius: '4px',
              marginLeft: '10px',
            }}
          >
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </Col>
      </Row>{' '}
      <div style={{ padding: '0 24px 24px' }}>
        {quizQuestionData?.length > 0 ? (
          <Table className='tablesorter'>
            <thead className='text-primary'>
              <tr>
                {/* <th>Question Range </th> */}
                <th>#</th>
                <th>Question</th>
                <th>Subject</th>
                <th>Topic</th>
                <th>Language </th>
                <th style={{ textAlign: 'center' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {quizQuestionData.map((quiz, index) => (
                <tr key={index}>
                  {/* <td style={{ width: 250 }}>{quiz?.questionNumber}</td> */}
                  <td>{index + 1}</td>
                  <td className={currentSubject == 'fganh' || currentSubject == 'हिंदी' ? 'hinditext' : '' } style={{ width: 250 }}>{quiz?.question}</td>
                  <td className={currentSubject == 'fganh' || currentSubject == 'हिंदी' ? 'hinditext' : '' } style={{ width: 150 }}>{quiz?.subject}</td>
                  <td className={currentSubject == 'fganh' || currentSubject == 'हिंदी' ? 'hinditext' : '' } style={{ width: 150 }}>{quiz?.topic}</td>
                  <td className={currentSubject == 'fganh' || currentSubject == 'हिंदी' ? 'hinditext' : '' } style={{ width: 150 }}>
                    {quiz?.questionLanguages?.join(', ')}
                  </td>
                  <td style={{ display:'flex',justifyContent:'center',alignItems:'center' }}>
                    <Button variant='primary' disabled={quiz?.isAlreadyAdded || (quizData?.numberOfQuation <= quizData?.quizQuestions?.length)} onClick={() => handleAddQuestion(quiz)}>{quiz?.isAlreadyAdded ?'Added':'Add'}</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <>
            {!loading && (
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  padding: '20px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  marginTop: '20px',
                }}
              >
                {searchQuery
                  ? 'No Question Availabe For This Search'
                  : ' No Questions Available'}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AddQuestionQuiz;
